import React, { useEffect, useState } from 'react';
import './ReviewListDrawer.css';
import api from '../../api';
import closeIcon from '../../assets/close-icon.png';

function ReadMore({ comment }) {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(!expanded);

  return (
    <div>
      <div className={`reviewdrawer-comment ${expanded ? 'expanded' : 'clamped'}`}>
        {comment}
      </div>
      <span className="readmore-toggle" onClick={toggle}>
        {expanded ? 'Show less' : 'Read more'}
      </span>
    </div>
  );
}



function ReviewListDrawer({ productId, isOpen, onClose }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await api.get(`/reviews/product/${productId}`);
        setReviews(res.data);
      } catch (err) {
        console.error('❌ Failed to fetch reviews:', err);
      } finally {
        setLoading(false);
      }
    };

    if (productId && isOpen) fetchReviews(); // Only fetch if visible
  }, [productId, isOpen]);

  if (!isOpen) return null; // Prevent rendering while closed

  return (
    <div className="reviewdrawer-backdrop" onClick={onClose}>
      <div
        className={`reviewdrawer-box ${isOpen ? 'open' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="reviewdrawer-header">
          <h3>Reviews</h3>
          <img
            src={closeIcon}
            alt="Close"
            className="reviewdrawer-close"
            onClick={onClose}
          />
        </div>

        {loading ? (
          <p className="reviewdrawer-loading">Loading reviews...</p>
        ) : reviews.length === 0 ? (
          <p className="reviewdrawer-empty">No reviews yet.</p>
        ) : (


<div className="reviewdrawer-list">
  {reviews.map((rev, idx) => (
    <div key={idx} className="reviewdrawer-item">

<div className="reviewdrawer-username">
  <strong>@{rev.username}</strong>
</div>


<ReadMore comment={rev.comment} />



      <div className="reviewdrawer-stars">
        {'★'.repeat(rev.rating)}{'☆'.repeat(5 - rev.rating)}
      </div>
    </div>
  ))}
</div>



        )}
      </div>
    </div>
  );
}

export default ReviewListDrawer;
